import { ReceiptItem, ReceiptNF } from "../../domain/models/receipt-model";
import { ReadReceiptNF } from "../../domain/usecases/read-receipt-nf";
import { Xml2JsonParser } from "../protocols/xml-parser/xml-2-json-parser";

export class ReadReceiptNFImplementation implements ReadReceiptNF {
  constructor(private readonly helper: Xml2JsonParser) {}
  read(xmlString: string): ReceiptNF | null {
    const json = this.helper.parse(xmlString);

    const obj = JSON.parse(json);

    const items: any = [];

    if (Array.isArray(obj?.nfeProc?.NFe?.infNFe?.det)) {
      obj?.nfeProc?.NFe?.infNFe?.det?.map((item: any) => {
        const it: Partial<ReceiptItem> = {};
        it.nItem = item?._attributes.nItem;
        it.reference = item?.prod?.cProd?._text;
        it.code = item?.prod?.cEAN?._text;
        it.name = item?.prod?.xProd?._text;
        it.unit = item?.prod?.uCom?._text;
        it.amount = parseFloat(item?.prod?.qCom?._text);
        items.push(it);
      });
    } else {
      const it: Partial<ReceiptItem> = {};
      it.nItem = obj?.nfeProc?.NFe?.infNFe?.det?._attributes.nItem;
      it.reference = obj?.nfeProc?.NFe?.infNFe?.det?.prod?.cProd?._text;
      it.code = obj?.nfeProc?.NFe?.infNFe?.det?.prod?.cEAN?._text;
      it.name = obj?.nfeProc?.NFe?.infNFe?.det?.prod?.xProd?._text;
      it.unit = obj?.nfeProc?.NFe?.infNFe?.det?.prod?.uCom?._text;
      it.amount = parseFloat(obj?.nfeProc?.NFe?.infNFe?.det?.prod?.qCom?._text);
      items.push(it);
    }

    const nf: ReceiptNF = {
      reference: obj.nfeProc.NFe.infNFe._attributes.Id,
      number: obj.nfeProc.NFe.infNFe.ide.nNF._text,
      dateOfIssue: obj.nfeProc.NFe.infNFe.ide.dhEmi._text,
      supplier: obj.nfeProc.NFe.infNFe.emit.xNome._text,
      supplierCnpj: obj.nfeProc.NFe.infNFe.emit.CNPJ._text,
      items,
      shippingCompanyCnpj:
        obj.nfeProc.NFe.infNFe?.transp?.transporta?.CNPJ?._text,
      shippingCompany: obj.nfeProc.NFe.infNFe?.transp?.transporta?.xNome?._text,
      truckPlate: obj.nfeProc.NFe.infNFe?.transp?.veicTransp?.placa?._text,
    };

    return nf;
  }
}
